import React, { useState } from "react";

function MoodTracker({ onSubmit, isPreSession = true, inline = false }) {
  const [moodRating, setMoodRating] = useState(5);
  const [note, setNote] = useState("");
  const [showNote, setShowNote] = useState(false);

  const question = isPreSession
    ? "How are you feeling right now?"
    : "How are you feeling now?";

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(moodRating, note);
  };

  const formContent = (
    <form
      onSubmit={handleSubmit}
      className={
        inline
          ? "w-full bg-session-bg-elevated text-session-text flex flex-col"
          : "w-full sm:max-w-md bg-session-bg-elevated text-session-text sm:rounded-2xl sm:shadow-xl flex flex-col"
      }
    >
      <div className="flex-1 px-6 pt-10 pb-6 sm:py-8 flex flex-col">
        <h2 className="text-2xl font-semibold text-session-text text-center mb-1">
          {question}
        </h2>
        <p className="text-sm text-session-text-secondary text-center mb-10">
          1 is rough, 10 is great.
        </p>

        <div className="mb-2 flex items-end justify-center gap-2">
          <span className="text-5xl font-bold text-session-accent leading-none">{moodRating}</span>
          <span className="text-base text-session-text-secondary mb-1">/ 10</span>
        </div>

        <input
          type="range"
          min="1"
          max="10"
          value={moodRating}
          onChange={(e) => setMoodRating(Number(e.target.value))}
          className="w-full h-2 mt-6 mb-1 accent-session-accent cursor-pointer"
          aria-label="Mood rating from 1 to 10"
        />
        <div className="flex justify-between text-xs text-session-text-secondary px-1">
          <span>1</span>
          <span>10</span>
        </div>

        {!showNote ? (
          <button
            type="button"
            onClick={() => setShowNote(true)}
            className="mt-8 self-center text-sm text-session-text-secondary hover:text-session-text transition"
          >
            + add a note
          </button>
        ) : (
          <textarea
            autoFocus
            placeholder="Anything on your mind? (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={3}
            className="mt-6 w-full bg-session-bg text-session-text border border-session-text-secondary/20 rounded-xl p-3 text-sm focus:border-session-accent focus:outline-none resize-none"
          />
        )}
      </div>

      <div className={`px-6 pb-6 sm:pb-8 ${inline ? "" : "sticky bottom-0 bg-session-bg-elevated border-t border-session-text-secondary/10 sm:border-0"} pt-4`}>
        <button
          type="submit"
          className="w-full bg-session-accent text-session-bg font-semibold py-4 rounded-xl hover:opacity-90 transition"
        >
          Continue
        </button>
      </div>
    </form>
  );

  if (inline) return formContent;

  return (
    <div data-testid="mood-overlay" className="fixed inset-0 z-50 bg-session-bg sm:bg-black/50 flex items-stretch sm:items-center justify-center sm:p-4">
      {formContent}
    </div>
  );
}

export default MoodTracker;
